module.exports = __webpack_public_path__ + "static/media/050-calendar copy 2.579541d1.svg";